var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isActive)?_c('div',{staticClass:"ui-vertical-tab"},[_c('h6',{staticClass:"ui-vertical-tab__title"},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }